import base from './component-base'
import i18n from '../utils/i18n'

export default function (data) {
  // console.debug('> Create page: ', data);
  console.debug('> Create page: ')

  return {
    mixins: [base],
    template: data.content.content,
    data: () => {
      console.debug('>> Initializing page data')
      return Object.assign({
      }, data.content, {
        // TODO: make it come from the server -> but then localization happens there, which will make it more
        //  fragmented (some front-end app messages will have to be localized here, some on the server side)
        nextLabel: data.next ? i18n.t('buttons.begin') : i18n.t('buttons.next'),
        next: data.next,
        previous: data.previous,
        allowNext: data.allowNext,
        allowPrev: data.allowPrev,
        allowSkip: true,
        displayTimer: false
      })
    },
    computed: {
      needsSubmit () {
        // Whether to display a Submit button when displaying this component as the last one
        return false
      },
      userCanFinish () {
        return false
      }
    },
    mounted () {
      console.log('> page ' + this.elementUid + ' (' + this.content + ') mounted')
      // TODO: make this into a property instead and set it in the component-base
    }
  }
}
